import {Component} from '@angular/core';
import {ProfileRouterUtil} from "../../profile-router.util";
import {ProfileMenuItem} from "./profile-menu-item.enum";

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.css']
})
export class ProfileMenuComponent {

  constructor(
    private readonly profileRouterUtil: ProfileRouterUtil
  ) {
  }

  get getMenuItems(): Array<ProfileMenuItem> {
    return this.profileRouterUtil.getMenuItems;
  }

  protected isRouteActive(item: ProfileMenuItem): boolean {
    return this.profileRouterUtil.isRouteActive(item);
  }

  protected navigateToPage(item: ProfileMenuItem): void {
    this.profileRouterUtil.navigateToPage(item);
  }
}
